export const ClientTaskType = {
  DocumentUpload: 0,
  Confirmation: 1,
  Questionnaire: 2,
} as const;

export type ClientTaskTypeValue = (typeof ClientTaskType)[keyof typeof ClientTaskType];

const LEGACY_CLIENT_TASK_TYPE_MAP: Record<string, ClientTaskTypeValue> = {
  Document_Upload: ClientTaskType.DocumentUpload,
  Confirmation: ClientTaskType.Confirmation,
  Questionnaire: ClientTaskType.Questionnaire,
};

export function normalizeClientTaskType(
  taskType: ClientTaskTypeValue | string | number | undefined | null,
): ClientTaskTypeValue | undefined {
  if (taskType === undefined || taskType === null) {
    return undefined;
  }

  if (typeof taskType === 'number') {
    return Object.values(ClientTaskType).includes(taskType as ClientTaskTypeValue)
      ? (taskType as ClientTaskTypeValue)
      : undefined;
  }

  const numeric = Number(taskType);
  if (!Number.isNaN(numeric) && Object.values(ClientTaskType).includes(numeric as ClientTaskTypeValue)) {
    return numeric as ClientTaskTypeValue;
  }

  return LEGACY_CLIENT_TASK_TYPE_MAP[taskType];
}
